import Config from '../../config';
import { NO_FLAG, IDLE_PROCESS_REFRESH_TIME } from '../constants';
import { QueryKeys, useCustomQuery } from './index';
import { useSelector } from 'react-redux';
import { lastClientIdSelector } from '../../userData/store/selectors';
import { useEffect } from 'react';
import { useQueryClient } from 'react-query';
import { isInitialDataLoadedSelector } from '../store/selectors';

export type IdleProcessValues = {
  periodName: string | null,
  taxYear: string | null,
  maintenanceFlag: string,
  lockFlag: string,
};
export const useIdleProcessValues = () => {
  const clientId = useSelector(lastClientIdSelector);
  const isInitialDataLoaded = useSelector(isInitialDataLoadedSelector);
  const queryClient = useQueryClient();

  useEffect(() => {
    if (typeof clientId === 'undefined') {
      return;
    }
    queryClient.resetQueries([QueryKeys.idleProcess.Values, clientId]);
  }, [clientId, queryClient]);

  return useCustomQuery<IdleProcessValues>(
    [QueryKeys.idleProcess.Values, clientId],
    {
      url: Config.endpoints.IDLE_PROCESSES,
      errorMessage: 'Fetching idle process values failed',
      defaultData: { periodName: null, taxYear: null, maintenanceFlag: NO_FLAG, lockFlag: NO_FLAG },
      refetchInterval: IDLE_PROCESS_REFRESH_TIME,
      enabled: isInitialDataLoaded,
    }
  );
};
